import { render, staticRenderFns } from "./bim.vue?vue&type=template&id=6adb9366&scoped=true"
import script from "./bim.vue?vue&type=script&lang=js"
export * from "./bim.vue?vue&type=script&lang=js"
import style0 from "./bim.vue?vue&type=style&index=0&id=6adb9366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adb9366",
  null
  
)

export default component.exports